// extracted by mini-css-extract-plugin
export default {"sections":"TransactionsDetails_sections__GnE79","vended":"TransactionsDetails_vended__4mpva","notVended":"TransactionsDetails_notVended__HgrZ6"};